// base64图片压缩

const dealImage = (base64, w, callback) => {
  let newImage = new Image();
  let quality = 0.6; // 压缩系数0-1之间
  newImage.src = base64;
  newImage.setAttribute("crossOrigin", "Anonymous"); // url为外域时需要
  let imgWidth, imgHeight;
  newImage.onload = function () {
    imgWidth = this.width;
    imgHeight = this.height;
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    if (Math.max(imgWidth, imgHeight) > w) {
      if (imgWidth > imgHeight) {
        canvas.width = w;
        canvas.height = (w * imgHeight) / imgWidth;
      } else {
        canvas.height = w;
        canvas.width = (w * imgWidth) / imgHeight;
      }
    } else {
      canvas.width = imgWidth;
      canvas.height = imgHeight;
      quality = 0.6;
    }
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
    let base64 = canvas.toDataURL("image/jpeg", quality); // 压缩语句
    // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
    // while (base64.length / 1024 > 150) {
    // 	quality -= 0.01;
    // 	base64 = canvas.toDataURL('image/jpeg', quality);
    // }
    // 防止最后一次压缩低于最低尺寸，只要quality递减合理，无需考虑
    // while (base64.length / 1024 < 50) {
    // 	quality += 0.001;
    // 	base64 = canvas.toDataURL('image/jpeg', quality);
    // }
    callback(base64); // 必须通过回调函数返回，否则无法及时拿到该值
  };
};
const downloadFileCustom = (res, fileName) => {
  if (!res) {
    return;
  }
  if (window.navigator.msSaveBlob) {
    // IE以及IE内核的浏览器
    try {
      window.navigator.msSaveBlob(res, fileName); // res为接口返回数据，这里请求的时候已经处理了，如果没处理需要在此之前自行处理var data = new Blob([res.data]) 注意这里需要是数组形式的,fileName就是下载之后的文件名
      // window.navigator.msSaveOrOpenBlob(res, fileName);  //此方法类似上面的方法，区别可自行百度
    } catch (e) {
      // // // console.log(e)
    }
  } else {
    let url = window.URL.createObjectURL(new Blob([res]));
    // let url = window.URL.createObjectURL(res)
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", fileName); // 文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // 下载完成移除元素
    window.URL.revokeObjectURL(url); // 释放掉blob对象
  }
};
// 获取当前日期YYYY-MM-DD
const getNowFormatDate = (seperator) => {
  let date = new Date();
  let seperator1 = seperator || "-";
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  let currentDate = year + seperator1 + month + seperator1 + strDate;
  return currentDate;
};

const getNowFormatDate2 = (seperator) => {
  let date = new Date();
  let seperator1 = seperator || "-";
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  let currentDate = year + month + strDate;
  return currentDate;
};

// 获取当前时间 时分秒 格式
const getTimeFormat = () => {
  var now = new Date();
  var hours = now.getHours();
  var minutes = now.getMinutes();
  var seconds = now.getSeconds();
  if (hours >= 1 && hours <= 9) {
    hours = "0" + hours;
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = "0" + minutes;
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = "0" + seconds;
  }
  return hours + ":" + minutes + ":" + seconds;
};

const getTimeFormat2 = () => {
  var now = new Date();
  var hours = now.getHours();
  var minutes = now.getMinutes();
  var seconds = now.getSeconds();
  if (hours >= 1 && hours <= 9) {
    hours = "0" + hours;
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = "0" + minutes;
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = "0" + seconds;
  }
  return hours + minutes + seconds;
};
// 获取当前星期
const getWeek = () => {
  var now = new Date();
  var dayOfWeek = now.getDay();
  const weekArr = ["日", "一", "二", "三", "四", "五", "六"];
  return "星期" + weekArr[dayOfWeek];
};
// 获取当前日期YYYY-MM-DD
const getNowFormatYear = () => {
  let date = new Date();
  let seperator1 = "-";
  let year = date.getFullYear();
  let currentDate = year + seperator1 + "01" + seperator1 + "01";
  return currentDate;
};
/**
 * 函数防抖 (只执行最后一次点击)
 * @param fn
 * @param delay
 * @returns {Function}
 * @constructor
 */
const debounce = (fn, t) => {
  let delay = t || 500;
  let timer;
  return function () {
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      timer = null;
      fn.apply(this, args);
    }, delay);
  };
};
/**
 * 函数节流
 * @param fn
 * @param interval
 * @returns {Function}
 * @constructor
 */
const throttle = (fn, t) => {
  let last;
  let timer;
  let interval = t || 500;
  return function () {
    let args = arguments;
    let now = +Number(new Date());
    if (last && now - last < interval) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        last = now;
        fn.apply(this, args);
      }, interval);
    } else {
      last = now;
      fn.apply(this, args);
    }
  };
};
const blobToText = (blob) => {
  return new Promise((resolve, reject) => {
    if (blob && blob.type !== "application/json") {
      // // console.log("blob", blob);
      resolve(blob);
    } else {
      const fileReader = new FileReader();
      fileReader.readAsText(blob);
      fileReader.onload = function () {
        // // console.log("fileReader", fileReader);
        try {
          const result = JSON.parse(fileReader.result);
          reject(result);
        } catch (e) {
          reject(e);
        }
      };
    }
  });
};
const dateFormat = (date, format = "yyyy-MM-dd") => {
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "q+": Math.floor((date.getMonth() + 3) / 3),
    "S+": date.getMilliseconds(),
  };
  if (/(y+)/.test(format)) {
    // 确保年的位数正确 yy 2位  yyyy4位
    format = format.replace(
      RegExp.$1,
      (date.getFullYear() + "").substring(4 - RegExp.$1.length)
    );
  }
  for (let i in o) {
    if (new RegExp("(" + i + ")").test(format)) {
      // // console.log(RegExp.$1+"---"+o[i],i)
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1
          ? o[i]
          : ("00" + o[i]).substring(("" + o[i]).length)
      );
    }
  }
  return format;
};

const treeForeach = (tree, func, childrenName = "children") => {
  let node,
    list = [...tree];
  while ((node = list.shift())) {
    func(node);
    node[childrenName] && list.push(...node[childrenName]);
  }
};

const downloadBase64 = (qrBase64, fileName) => {
  if (window.navigator.msSaveOrOpenBlob) {
    const bstr = atob(qrBase64.split(",")[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const blob = new Blob([u8arr]);
    window.navigator.msSaveOrOpenBlob(blob, fileName + "." + "png");
  } else {
    const a = document.createElement("a");
    a.href = qrBase64;
    a.setAttribute("download", fileName);
    a.click();
  }
};
// 深拷贝方法
const deepClone = function (obj) {
  if (typeof obj != "object") return obj;
  var temp = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] && typeof obj[key] == "object") {
        // console.log(key, "000000");
        temp[key] = deepClone(obj[key]);
      } else {
        temp[key] = obj[key];
      }
    }
  }
  return temp;
};
// 截取邮箱@前值
const getEmailFirstRegex = function (email) {
  if (!email) {
    return null;
  }
  return email.split("@")[0];
};
// 截取邮箱@前值
const getEmailEndRegex = function (email) {
  if (!email) {
    return null;
  }
  return "@" + email.split("@")[1];
};
// 转大写中文金额
const toChineseMoney = function (number) {
  if (isNaN(number) || !isFinite(number)) {
    throw new Error("传值错误");
  }
  if (Number(number) === 0) {
    return "零元";
  }
  const fraction = ["角", "分"];
  const digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
  const unit = [
    ["元", "万", "亿"],
    ["", "拾", "佰", "仟"],
  ];
  let num = Math.abs(number);
  let s = "";
  const decimalPart = Math.floor((num * 100) % 100);
  fraction.forEach((item, index) => {
    s += (
      digit[Math.floor(decimalPart / 10 ** (1 - index)) % 10] + item
    ).replace(/零./, "");
  });
  s = s || "";
  num = Math.floor(num);
  for (let i = 0; i < unit[0].length && num > 0; i += 1) {
    let p = "";
    for (let j = 0; j < unit[1].length && num > 0; j += 1) {
      p = digit[num % 10] + unit[1][j] + p;
      num = Math.floor(num / 10);
    }
    s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
  }
  return s
    .replace(/(零.)*零元/, "元")
    .replace(/(零.)+/g, "零")
    .replace(/^元$/, "零元");
};

const getNewDay = function (dateTemp, days) {
  dateTemp = dateTemp.split("-");
  //转换为MM-DD-YYYY格式
  var nDate = new Date(dateTemp[1] + "-" + dateTemp[2] + "-" + dateTemp[0]);
  var millSeconds = Math.abs(nDate) + days * 24 * 60 * 60 * 1000;
  var rDate = new Date(millSeconds);
  var year = rDate.getFullYear();
  var month = rDate.getMonth() + 1;
  if (month < 10) month = "0" + month;
  var date = rDate.getDate();
  if (date < 10) date = "0" + date;
  return year + "-" + month + "-" + date;
};

const qfw = function (number) {
  if (number == null) return "";
  if (number == undefined) return "";
  // 将数字转换为字符串
  const numStr = number.toString();

  // 检查是否为负数
  const isNegative = numStr[0] === "-";
  const absoluteNumStr = isNegative ? numStr.slice(1) : numStr;

  // 分割整数部分和小数部分
  const [integerPart, decimalPart] = absoluteNumStr.split(".");

  let formattedInteger = "";
  let count = 0;

  // 从后往前遍历整数部分
  for (let i = integerPart.length - 1; i >= 0; i--) {
    formattedInteger = integerPart[i] + formattedInteger;
    count++;
    if (count % 3 === 0 && i !== 0) {
      formattedInteger = "," + formattedInteger;
    }
  }

  // 拼接小数部分
  let result = formattedInteger;
  if (decimalPart) {
    result += "." + decimalPart;
  }

  // 如果是负数，添加负号
  if (isNegative) {
    result = "-" + result;
  }

  return result;
};
const getFileUrl = function (fileId) {
  let path =
    process.env.VUE_APP_BASE_PATH +
    process.env.VUE_APP_REMOTE_API +
    "/pmy/file/sys-file/download?fileId=" +
    fileId;
  return path;
};
/**
 * 数字转千分位带逗号
 * @param {number|string} num 原始数字 1234567.88
 * @returns {string} "1,234,567.88"
 */
const numberToThousand = function(num) {
  if (num === null || num === undefined || num === '') return '0.00'
  const val = Number(num)
  if (isNaN(val)) return '0.00'
  // 保留2位小数，千分位逗号
  return val.toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}
export {
  qfw,
  dealImage,
  numberToThousand,
  getEmailFirstRegex,
  getEmailEndRegex,
  downloadFileCustom,
  getNowFormatYear,
  getNowFormatDate,
  debounce,
  getFileUrl,
  throttle,
  blobToText,
  dateFormat,
  treeForeach,
  downloadBase64,
  deepClone,
  toChineseMoney,
  getTimeFormat,
  getWeek,
  getTimeFormat2,
  getNowFormatDate2,
  getNewDay,
};
